'use client';

import Link from 'next/link';
import type { VerseReference } from '@/lib/types';

interface VerseCardProps {
  verse: VerseReference;
}

export default function VerseCard({ verse }: VerseCardProps) {
  return (
    <Link
      href={`/reader/${encodeURIComponent(verse.book)}/${verse.chapter}`}
      className="block p-3 rounded-lg transition-all duration-200"
      style={{
        backgroundColor: 'var(--bg-card)',
        border: '1px solid rgba(200, 164, 94, 0.1)',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = 'rgba(200, 164, 94, 0.3)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'rgba(200, 164, 94, 0.1)';
      }}
    >
      <div className="flex items-center gap-2 mb-1.5">
        <span
          className="text-sm font-semibold"
          style={{ color: 'var(--accent-gold)' }}
        >
          {verse.book} {verse.chapter}:{verse.verse}
        </span>
        {verse.translation && (
          <span
            className="text-xs px-1.5 py-0.5 rounded"
            style={{
              backgroundColor: 'rgba(74, 125, 189, 0.15)',
              color: 'var(--accent-blue)',
            }}
          >
            {verse.translation.toUpperCase()}
          </span>
        )}
      </div>
      <p
        className="text-xs leading-relaxed line-clamp-3"
        style={{ color: 'var(--text-secondary)' }}
      >
        {verse.text}
      </p>
    </Link>
  );
}
